import PartnerDomainsTable from "./PartnerDomainsTable";

export default PartnerDomainsTable;


// WEBPACK FOOTER //
// ./src/scenes/PartnerDomains/components/PartnerDomainsTable/index.js